import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import PlusConfigProvider from '@fle-ui/plus-config-provider';

import Router from '@/router';
import { fleAppEnv } from './const/serviceEnv';
import { checkTokenByPlatform } from './tools/checkTokenByPlatform';
import { theme } from './tools/theme';

import '@/theme/reset.less';
import '@/style/index.less';

// 校验token是否是当前应用的token
checkTokenByPlatform();


const container = document.getElementById('root');

const root = ReactDOM.createRoot(container!);
window.localStorage.setItem('env', fleAppEnv || '');

root.render(
  <PlusConfigProvider theme={theme}>
    <Router />
  </PlusConfigProvider>,
);
